import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { CAR_API_URL, DICT_API, KEY_API_URL, PPP_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class CarService {
  static getCarList = async (data = {}, offset = 0, limit = 20) => {
    try {
      const res = await HTTPHandler.post(CAR_API_URL + '/cars/list', {
        ...data,
        offset,
        limit
      })
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getBrands = async () => {
    try {
      const res = await HTTPHandler.get(CAR_API_URL + '/dictionary/markas')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
  /**
   * @async
   * @function getCarByProductCode
   * @param {string|number} productCode  0
   * @return {Object} Car
   * @example getCarByProductCode(code)
   *
   */
  static getCarByProductCode = async productCode => {
    try {
      const res = await HTTPHandler.get(
        `${CAR_API_URL}/cars/getByProductCode/` + productCode
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
  static getInteriorMaterials = async () => {
    try {
      const res = await HTTPHandler.get(
        CAR_API_URL + '/dictionary/interiorMaterials'
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getBodyTypes
   * getBodyTypes
   * @return  {Object} bodyTypes
   * @example getBodyTypes()
   *
   */
  static getBodyTypes = async () => {
    try {
      const res = await HTTPHandler.get(CAR_API_URL + '/dictionary/bodyTypes')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
  /**
   * @async
   * @function getColors
   * getColors
   * @return  {Object} bodyTypes
   * @example getColors()
   *
   */
  static getColors = async () => {
    try {
      const res = await HTTPHandler.get(CAR_API_URL + '/dictionary/colors')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
  /**
   * @async
   * @function getDwheelTypes
   * getDwheelTypes
   * @return  {Object} dwheelTypes
   * @example getDwheelTypes()
   *
   */
  static getDwheelTypes = async data => {
    try {
      const res = await HTTPHandler.get(CAR_API_URL + '/dictionary/dwheelTypes')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getEngineTypes
   * getEngineTypes
   * @return  {Object} engineTypes
   * @example getEngineTypes()
   *
   */
  static getEngineTypes = async () => {
    try {
      const res = await HTTPHandler.get(CAR_API_URL + '/dictionary/engineTypes')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getRuBrands
   * getRuBrands
   * @return  {Object} marks
   * @example getRuBrands()
   *
   */
  static getRuBrands = async () => {
    try {
      const res = await HTTPHandler.get(DICT_API + '/catalog/markas')
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getRuModels
   * getRuModels
   * @param {number|string} brandId
   * @return  {Object} models
   * @example getRuModels(1)
   *
   */
  static getRuModels = async brandId => {
    try {
      const res = await HTTPHandler.get(DICT_API + '/catalog/models/' + brandId)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getRuYears
   * getRuYears
   * @param {number|string} modelId
   * @return  {Object} years
   * @example getRuYears()
   *
   */
  static getRuYears = async modelId => {
    try {
      const res = await HTTPHandler.get(
        DICT_API + '/catalog/getModelMinMaxYear/' + modelId
      )
      res.data = [
        ...Array(Number(res.data.maxYear - res.data.minYear) + 1)
      ].map((x, i) => res.data.minYear + i)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getRuBodyTypes
   * getRuBodyTypes
   * @param {number|string} modelId
   * @param {number|string} year
   * @return  {Object} bodyTypes
   * @example getRuBodyTypes(1,1999)
   *
   */
  static getRuBodyTypes = async (modelId, year) => {
    try {
      const res = await HTTPHandler.get(
        `${DICT_API}/catalog/getBodyTypes/${modelId}/${year}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getRuGenerations
   * getRuGenerations
   * @param {number|string} modelId
   * @param {number|string} year
   * @param {number|string} bodyType
   * @return  {Object} RuGenerations
   * @example getRuGenerations(1,1999)
   *
   */
  static getRuGenerations = async (modelId, year, bodyType) => {
    try {
      const res = await HTTPHandler.post(
        `${DICT_API}/catalog/getGenerations/${modelId}/${year}?bodyType=${bodyType}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getRuModifications
   * getRuModifications
   * @param {number|string} bodyType
   * @param {number|string} year
   * @param {number|string} generationId
   * @return  {Object} RuModifications
   * @example getRuModifications(1,1999)
   *
   */
  static getRuModifications = async (bodyType, year, generationId) => {
    try {
      const res = await HTTPHandler.post(
        `${DICT_API}/catalog/getModifications?bodyType=${bodyType}&year=${year}&generationId=${generationId}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static uploadPhotos = async (files = []) => {
    try {
      const formData = new FormData()
      for (let i = 0; i < files.length; i++) {
        formData.append(`file`, files[i])
      }
      const res = await HTTPHandler.post(
        CAR_API_URL + '/files/uploadFiles',
        formData,
        {
          'Content-Type': 'multipart/form-data'
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static checkKeysStatus = async (vins = []) => {
    try {
      const res = await HTTPHandler.post(
        `${KEY_API_URL}/keys/checkKeysStatus`,
        {
          vins
        }
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static acceptKey = async (id, saleId) => {
    try {
      const res = await HTTPHandler.post(`${KEY_API_URL}/keys/acceptKey`, {
        id,
        saleId: saleId
      })
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  /**
   * @async
   * @function getCarValueByVin
   * @param {string|number} vin  0
   * @return {Object} value
   * @example getCarValueByVin(vin)
   *
   */
  static getCarValueByVin = async vin => {
    try {
      const res = await HTTPHandler.get(
        `${PPP_API_URL}/cars/getValueByVin/` + vin
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getCarByVin = async vin => {
    try {
      const response = await HTTPHandler.get(
        CAR_API_URL + `/cars/getByVin/${vin}`
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }
}
